<template>
  <div>
    <div v-if="tags" class="line-chart-box">
      <div
        v-for="item in showTags"
        :key="item.class"
        :class="`tag ${item.class}`"
      >
        <p v-if="type === 'object'">
          <span>{{ tags[item.index].tag }}</span>
          <span v-if="showTagLabel(tags[item.index])"
            >（{{ tags[item.index].label }}）</span
          >
        </p>
        <span v-else>{{ tags[item.index] }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tags: { type: Array, default: () => [] },
  },
  data() {
    return {
      lineChat: [
        { index: 0, class: 'first' },
        { index: 1, class: 'second' },
        { index: 2, class: 'third' },
        { index: 3, class: 'fourth' },
        { index: 4, class: 'fifth' },
      ],
    }
  },
  computed: {
    type() {
      return typeof this.tags[0]
    },
    showTags() {
      const arr = []
      this.lineChat.forEach((v,i)=>{
        if(i< this.tags.length) arr.push(v)
      })
      return arr
    },
  },
  methods: {
    showTagLabel(tag) {
      const showTypes = ['平台', '业绩']
      return !!showTypes.includes(tag.label)
    },
  },
}
</script>
<style scoped>
.tag {
  color: #fff;
  text-align: center;
  line-height: 22px;
  border-radius: 4px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  margin-bottom: 6px;
}
.first {
  background-color: #fbdee0;
  color: #de5c65;
  width: 100%;
  min-width: 245px;
}
.second {
  background-color: #fce1b8;
  width: 90%;
  min-width: 210px;
  color: #ed9f2b
}
.third {
  background-color: #CBE9F4;
  color:#2E99BF;
  width: 80%;
  min-width: 170px;
}
.fourth {
  background-color: #E6F0FA;
  color:#3D5C72;
  width: 70%;
  min-width: 130px;
}
.fifth {
  background-color: #D1EAE6;
  color:#64B9A1;
  width: 60%;
  min-width: 90px;
  margin-bottom: 0px;
}
</style>
